import React, { useEffect, useState } from "react";
import "../assets/css/secondaryPayment.css";
import SubHero from "../components/SubHero";
import SecondaryModal from "../components/SecondaryModal";
import axios from "axios";
import MultipleFormModal from "../components/MultipleFormModal";

const InstallmentalPayment = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [formData, setFormData] = useState({
    fullName: "",
    course: "",
    email: "",
    phone: "",
    installmentType: "",
    terms: false,
  });

  const [status, setStatus] = useState({
    isSuccessfull: false,
    active: false,
    message: "",
  });

  const handleOnchange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const payload = {
      fullName: formData.fullName,
      course: formData.course,
      email: formData.email,
      phone: formData.phone,
      installmentType:
        formData.installmentType === "First Payment" ? "first" : "second",
      terms: formData.terms,
    };

    try {
      const response = await axios.post(
        "https://nexatrux.com/backend/public/api/enroll-installment",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setStatus({
          isSuccessfull: true,
          active: true,
          message:
            response.data.message || "Enrollment submitted successfully!",
        });

        // Reset form after successful submission
        setFormData({
          fullName: "",
          course: "",
          email: "",
          phone: "",
          installmentType: "",
          terms: false,
        });

        // Close modal after 3-4s
        setTimeout(() => {
          setIsOpen(false);
          setStatus({ ...status, active: false });
        }, 4000);
      }
    } catch (error) {
      console.error("Submission error:", error);
      setStatus({
        isSuccessfull: false,
        active: true,
        message:
          "Something went wrong. Please check your network and try again later.",
      });

      setTimeout(() => {
        setStatus({ ...status, active: false });
      }, 4000);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <section className="secondary-payment-container">
      <SubHero name="secondary-payment" />
      <div className="secondary-payment-content"></div>

      {isOpen && (
        <SecondaryModal setIsOpen={setIsOpen}>
          <h3>Flexible Payment Plans</h3>
          <p>
            Select your payment type. Make sure your transfer is successful
            before clicking <strong>Transfer Made</strong> to avoid money loss.
            Send payment evidence to{" "}
            <span className="highlight">+234 810 518 2900</span> or{" "}
            <span className="highlight">+234 703 133 7482</span> for
            confirmation.
          </p>
          <p>________________</p>

          <p>
            Please fill out the form below to proceed with your payment:
            <br />
            Account Number: <span className="highlight">6105121692</span>
            <br />
            Bank: OPay
            <br />
            Account Name: NEXA TRUX DIGITAL TECHNOLOGY
          </p>

          <form className="coupon-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              placeholder="Full Name"
              onChange={handleOnchange}
              required
            />
            <input
              type="text"
              name="course"
              value={formData.course}
              placeholder="Course"
              onChange={handleOnchange}
              required
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              placeholder="Email"
              onChange={handleOnchange}
              required
            />
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              placeholder="Phone Number"
              onChange={handleOnchange}
              required
            />

            <div className="select-container">
              <label htmlFor="installmentType">Payment Type</label>
              <select
                id="installmentType"
                name="installmentType"
                value={formData.installmentType}
                onChange={handleOnchange}
                required
              >
                <option value="">Select a payment plan</option>
                <option value="First Payment">First payment</option>
                <option value="Second Payment">Second payment</option>
              </select>
            </div>

            <label className="gap">
              <input
                type="checkbox"
                name="terms"
                checked={formData.terms}
                onChange={handleOnchange}
                required
              />
              <span>I agree to the privacy policy terms</span>
            </label>

            <button className="btn2 center">Transfer Made</button>
          </form>
        </SecondaryModal>
      )}

      {status.active && <MultipleFormModal modalStatus={status} />}
    </section>
  );
};

export default InstallmentalPayment;
